"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _side = _interopRequireDefault(require("./side.js"));
var _corner = _interopRequireDefault(require("./corner.js"));
var _SpriteWrapper = _interopRequireDefault(require("../SpriteWrapper"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* eslint-disable global-require */
var _default = exports["default"] = function _default(urls) {
  _side["default"].images = urls.side;
  _corner["default"].images = urls.corner.slice(0, 1);
  return {
    Corner: function Corner(props) {
      return /*#__PURE__*/_react["default"].createElement(_SpriteWrapper["default"], _extends({}, props, {
        spriteProps: {
          spriteClass: _style["default"].cornerSprite,
          width: 420,
          height: 420,
          zoe: _corner["default"]
        },
        talkAnimation: "all",
        idleAnimation: "all"
      }));
    },
    Middle: function Middle(props) {
      return /*#__PURE__*/_react["default"].createElement(_SpriteWrapper["default"], _extends({}, props, {
        spriteProps: {
          spriteClass: _style["default"].middleSprite,
          width: 420,
          height: 1160,
          zoe: _side["default"]
        },
        talkAnimation: "talkCycle",
        idleAnimation: "Idle"
      }));
    },
    Side: function Side(props) {
      return /*#__PURE__*/_react["default"].createElement(_SpriteWrapper["default"], _extends({}, props, {
        spriteProps: {
          spriteClass: _style["default"].sideSprite,
          width: 420,
          height: 1160,
          zoe: _side["default"]
        },
        talkAnimation: "talkCycle",
        idleAnimation: "Idle"
      }));
    },
    assets: []
  };
};